export const VipInfo18n = {
	zh: {
		'vipInfo-title': '会员权益',
		'vipInfo-card-title-1': '开通会员',
		'vipInfo-card-title-2': '升级会员',
		'vipInfo-card-title-3': '我的会员',
		'vipInfo-card-title-4': '到期时间',
		'vipInfo-card-title-5': '未开通会员',
		'vipInfo-card-title-6': '永久有效',
		'vipInfo-card-btn': '续费',
		'vipInfo-info-title-1': '升级会员享特权',
		'vipInfo-info-title-2': '升级享更多特权',
		'vipInfo-info-title-3': '专业会员特权',
		'vipInfo-btn-1': '开通高级会员',
		'vipInfo-btn-2': '升级超级会员',
		'vipInfo-btn-3': '升级专业会员',
		'vipInfo-btn-4': '续费专业会员',
		'vipInfo-info-1': '存储',
		'vipInfo-info-2': '协同',
		'vipInfo-info-3': 'Web3',
		'vipInfo-list-1-1-1': '3GB IPFS分布式存储空间',
		'vipInfo-list-1-1-2': 'IPFS 名片管理',
		'vipInfo-list-1-2-0': '会议时长不限',
		'vipInfo-list-1-2-1': '会议创建次数不限',
		'vipInfo-list-1-2-2': '最高入会方数300',
		'vipInfo-list-1-2-3': '指定参会成员',
		'vipInfo-list-1-2-4': '状态更新',
		'vipInfo-list-1-2-5': '智能合同',
		'vipInfo-list-1-2-6': '伙伴成功',
		'vipInfo-list-2-1-1': '5GB IPFS分布式存储空间',
		'vipInfo-list-2-2-1': '最高入会方数300',
		'vipInfo-list-2-3-1': '跨域专网',
		'vipInfo-list-2-3-2': '智能账户',
		'vipInfo-list-2-3-3': '链上数据分析与风险预警',
		'vipInfo-list-2-3-4': '链上结构化产品信息服务',
		'vipInfo-list-3-2-1': '最高入会方数300',
		'vipInfo-list-3-3-1': '节点扩展',
		'vipInfo-list-3-3-2': '开放平台',
		'vipInfo-go-app': '请前往“链上会”App开通会员',
		'vipInfo-go-app-confirm': '我知道了'
	},
	en: {
		'vipInfo-title': 'Member Benefits',
		'vipInfo-card-title-1': 'Join Membership',
		'vipInfo-card-title-2': 'Upgrade Membership',
		'vipInfo-card-title-3': 'My Member',
		'vipInfo-card-title-4': 'Expire Date',
		'vipInfo-card-title-5': 'Unregistered Member',
		'vipInfo-card-title-6': 'Permanent',
		'vipInfo-card-btn': 'Recharge',
		'vipInfo-info-title-1': 'Upgrade membership to enjoy privileges',
		'vipInfo-info-title-2': 'Upgrade to enjoy more privileges',
		'vipInfo-info-title-3': 'Professional membership </br> privileges',
		'vipInfo-btn-1': 'Switch to Premium',
		'vipInfo-btn-2': 'Upgrade to Super',
		'vipInfo-btn-3': 'Upgrade to Professional',
		'vipInfo-btn-4': 'Recharge',
		'vipInfo-info-1': 'ChainDoc',
		'vipInfo-info-2': 'Collaborative',
		'vipInfo-info-3': 'Web3',
		'vipInfo-list-1-1-1': '3GB of IPFS Distributed Storage',
		'vipInfo-list-1-1-2': 'IPFS Business Card Management',
		'vipInfo-list-1-2-0': 'Unlimited meeting length',
		'vipInfo-list-1-2-1': 'Unlimited meeting creation',
		'vipInfo-list-1-2-2': '300 max attendees',
		'vipInfo-list-1-2-3': 'Private Meeting',
		'vipInfo-list-1-2-4': 'Status Update',
		'vipInfo-list-1-2-5': 'Smart Contract',
		'vipInfo-list-1-2-6': 'Partner Success',
		'vipInfo-list-2-1-1': '5GB of IPFS Distributed Storage',
		'vipInfo-list-2-2-1': '300 max attendees',
		'vipInfo-list-2-3-1': 'CDNM',
		'vipInfo-list-2-3-2': 'Smart Account',
		'vipInfo-list-2-3-3': 'On-Chain Data Analysis and Risk Warning',
		'vipInfo-list-2-3-4': 'On-Chain Structured Product Trading Platform',
		'vipInfo-list-3-2-1': '300 max attendees',
		'vipInfo-list-3-3-1': 'Node Expansion',
		'vipInfo-list-3-3-2': 'Open Platform',
		'vipInfo-go-app': 'Please go to the "ChainPal" App to activate membership',
		'vipInfo-go-app-confirm': 'OK'
	},
}

